import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackageDemo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group 2406",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M14.7134 4.60871L8.65985 7.24142V16.4136L16 13.223V4.05075L14.7134 4.60871Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M4.32668 7.10399C4.32668 7.27812 4.2575 7.44512 4.13438 7.56824C4.01125 7.69137 3.84426 7.76054 3.67013 7.76054C3.496 7.76054 3.329 7.69137 3.20588 7.56824C3.08275 7.44512 3.01358 7.27812 3.01358 7.10399V5.36417L0 4.05107V13.223L7.34679 16.4139V7.24846L4.32668 5.92879V7.10399Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M14.9955 3.05307L12.3232 1.89111L5.32434 4.93063L8.00309 6.09259L14.8183 3.13162L14.9955 3.05307Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M10.695 1.16846L8.00323 0L0.984863 3.04657L3.67011 4.21503L10.695 1.16846Z",
				fill: "currentColor"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgPackageDemo);
export { ForwardRef as ReactComponent };
